import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { OfferIface } from '../../../../interfaces/offer.iface';
import { DataHelper } from '../../../../helpers/data-helper';
import { Tag } from '../../../../interfaces/tag';

@Component({
  selector: 'app-edit-tags-dialog',
  templateUrl: './edit-tags-dialog.component.html',
  styleUrls: ['./edit-tags-dialog.component.scss']
})
export class EditTagsDialogComponent {
  public offer: OfferIface;
  public header: string;
  public property: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { property: string; offer: OfferIface },
    public dialogRef: MatDialogRef<EditTagsDialogComponent>
  ) {
    this.offer = data.offer;
    this.property = data.property;
    this.header = DataHelper.mapPropsToHeader(data.property);
  }

  add(value: string): void {
    if (value.length > 0) {
      this.offer[this.property].push(value);
    }
  }

  remove(value: Tag): void {
    const idx = this.offer[this.property].indexOf(value);
    if (idx > -1) {
      this.offer[this.property].splice(idx, 1);
    }
  }

  save(): void {
    this.dialogRef.close(this.offer);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/campaigns/edit-tags-dialog/edit-tags-dialog.component.ts